export default __webpack_public_path__ + "static/media/Kohli.3e682164.jpeg";